<template>
    <section class="banner_area">
      <div class="banner_inner d-flex align-items-center">
        <div class="container">
          <div class="banner_content d-md-flex justify-content-between align-items-center">
            <div class="mb-3 mb-md-0">
              <h2 class="text-capitalize">{{title}}</h2>
            </div>
            <div class="page_link">
              <a href="/">Home</a>
              <a class="text-muted" href="#">{{title}}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
export default {
  props: ['title']
}
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue